import { render, staticRenderFns } from "./TakePicture.vue?vue&type=template&id=8ebf3ba2"
import script from "./TakePicture.vue?vue&type=script&lang=js"
export * from "./TakePicture.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports